exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid_menu {\n  background-color: #292C33;\n  height: 40px;\n  width: 40px;\n  border-bottom-right-radius: 0.5rem;\n  border-top-right-radius: 0.5rem;\n  position: fixed;\n  top: 50%;\n  left: 0;\n  transition: left 0.4s;\n  z-index: 100; }\n\n.grid_menu_image {\n  padding-top: 10px;\n  height: 30px;\n  width: 30px;\n  cursor: pointer; }\n\n.grid_menu_image_c {\n  margin-top: 10px;\n  margin-left: -30px;\n  height: 40px;\n  width: 40px;\n  cursor: pointer; }\n\n.checkbox:checked ~ .grid_menu {\n  left: 4%;\n  border-radius: 0 0.5rem 0.5rem 0;\n  opacity: 0.8; }\n\n.left-panel {\n  position: fixed;\n  width: 4%;\n  height: 100%;\n  background-color: #292C33;\n  top: 0;\n  left: -30%;\n  transition: left 0.4s;\n  opacity: 0.8;\n  z-index: 100; }\n\n.left-panel a {\n  text-decoration: none; }\n\n.checkbox:checked ~ .left-panel {\n  left: 0; }\n\n.checkbox {\n  display: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/shared/menu-side/menu-side.component.scss
// module id = ../../../../../src/app/shared/menu-side/menu-side.component.scss
// module chunks = main